export default {
    title: 'Ideo Cards',
    subtitle: "Look up a training course or an occupation in ONISEP's IDEO catalogue.",
    view: 'View',
    empty: 'No card matches this search.',
    loadError: 'The Ideo cards could not be loaded.',
    refine: 'More than {count} cards match: refine your search.',
    tabs: {
        formations: 'Formations',
        metiers: 'Occupations',
    },
    search: {
        formations: 'Search a formation by name, Ideo 2 ID or Ideo 1 ID...',
        metiers: 'Search an occupation by name, Ideo 2 ID or Ideo 1 ID...',
    },
    table: {
        idIdeo2: 'ID Ideo 2',
        idIdeo1: 'ID Ideo 1',
        name: 'Name',
        actions: 'Actions',
    },
    detail: {
        idIdeo2: 'ID Ideo 2',
        idIdeo1: 'ID Ideo 1',
        accroche: 'Description',
        niveauEtude: 'Education level',
        statutExercice: 'Employment status',
        domaines: 'Domains',
        sousDomaines: 'Sub-domains',
        centresInteret: 'Areas of interest',
        formations: 'Related formations',
        notFound: 'This card is no longer in the IDEO catalogue.',
        loadError: 'The card could not be loaded.',
    },
}
